module.exports = __webpack_public_path__ + "img/l-1.e1b0127.png";